import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Task } from '../../account/models/Task';
import { environment } from '../../../../environments/environment';
import { Licence } from '../../supplier/models/Licence';
import { RequestStatusFui } from '../../supplier/models/RequestStatusFui';
import { OperatorList } from '../../operator/models/OperatorList';
import { TaskFilterForm } from '../../shared/models/TaskFilterForm';
import { Page } from '../../../shared/model/page';
import { NotificationFilterForm } from '../notifications-anre/models/NotificationFilterForm';
import { Notification } from '../../account/models/Notification';
import { SupplierFilterForm } from '../notifications-anre/models/SupplierFilterForm';
import { Supplier } from '../../supplier/models/Supplier';
import { Operator } from '../../operator/models/Operator';
import {UtilService} from '../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class AnreService {

  constructor(private http: HttpClient,
              private utils: UtilService) {
  }

  getAnreTask(taskId: number): Observable<any> {
    return this.http.get<any>(environment.baseUrl + `/task/${taskId}`);
  }

  getAnreTasks(taskFilterForm: TaskFilterForm): Observable<Page<Task>> {
    return this.http.post<Page<Task>>(environment.baseUrl + '/task/anre', taskFilterForm);
  }

  assignAnreTask(taskId: number): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/task/${taskId}/assign`, {});
  }

  resolveAnreTask(taskId: number, task: any): Observable<void> {
    return this.http.put<void>(environment.baseUrl + `/task/${taskId}/resolve`, task);
  }

  getAnreNotifications(notificationFilterForm: NotificationFilterForm): Observable<Page<Notification>> {
    return this.http.post<Page<Notification>>(environment.baseUrl + '/message/anre', notificationFilterForm);
  }

  getAnreElectricSuppliers(supplierFilterForm: SupplierFilterForm): Observable<Page<Supplier>> {
    return this.http.post<Page<Supplier>>(environment.baseUrl + `/furnizor/lista-furnizori/electricity`, supplierFilterForm);
  }

  getAnreGasSuppliers(supplierFilterForm: SupplierFilterForm): Observable<Page<Supplier>> {
    return this.http.post<Page<Supplier>>(environment.baseUrl + `/furnizor/lista-furnizori/gas`, supplierFilterForm);
  }

  changeLicenceStatus(licence: Licence): Observable<Licence> {
    return this.http.post<Licence>(environment.baseUrl + '/licenta/schimbare-status', licence);
  }

  changeRequestStatusFui(requestStatusFui: RequestStatusFui): Observable<RequestStatusFui> {
    return this.http.post<RequestStatusFui>(environment.baseUrl + '/licenta/schimbare-status-fui', requestStatusFui);
  }

  cancelLicenceStatus(licence: Licence): Observable<Licence> {
    return this.http.post<Licence>(environment.baseUrl + '/licenta/anulare-cerere', licence);
  }

  cancelRequestStatusFui(requestStatusFui: RequestStatusFui): Observable<RequestStatusFui> {
    return this.http.post<RequestStatusFui>(environment.baseUrl + '/licenta/anulare-request-status-fui', requestStatusFui);
  }

  getLicence(licenceCode: string): Observable<Licence> {
    return this.http.get<Licence>(environment.baseUrl + `/licenta/find-by-series/${licenceCode}`);
  }

  getAnreElectricOperators(name: string, code: string, page: number, size: number): Observable<OperatorList> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(name)) {
      params = params.append('name', name);
    }
    if (this.utils.nonNullAndNonUndefined(code)) {
      params = params.append('code', code);
    }
    if (this.utils.nonNullAndNonUndefined(page)) {
      params = params.append('page', page);
    }
    if (this.utils.nonNullAndNonUndefined(size)) {
      params = params.append('size', size);
    }
    return this.http.get<OperatorList>(environment.baseUrl + `/operator/lista-operatori/electricity`, {params});
  }

  getAnreGasOperators(name: string, code: string, page: number, size: number): Observable<OperatorList> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(name)) {
      params = params.append('name', name);
    }
    if (this.utils.nonNullAndNonUndefined(code)) {
      params = params.append('code', code);
    }
    if (this.utils.nonNullAndNonUndefined(page)) {
      params = params.append('page', page);
    }
    if (this.utils.nonNullAndNonUndefined(size)) {
      params = params.append('size', size);
    }
    return this.http.get<OperatorList>(environment.baseUrl + `/operator/lista-operatori/gas`, {params});
  }

  modifySupplierIntegration(supplier: Supplier): Observable<Supplier> {
    return this.http.put<Supplier>(environment.baseUrl + '/furnizor/integrated-status-update', supplier);
  }

  modifyOperatorIntegration(operator: Operator): Observable<Operator> {
    return this.http.put<Operator>(environment.baseUrl + '/operator/integrated-status-update', operator);
  }
}
